import * as Stimulus from "@hotwired/stimulus"

/**
 * Ensures at least one checkbox is checked.
 *
 * Required Attributes
 *
 *  Controller:
 *      - data-controller="checkbox-validation"
 *      - data-action="change->checkbox-validation#validate"
 *
 *  Inputs:
 *      - data-checkbox-validation-target="input"
 *
 */
export class CheckboxValidationController extends Stimulus.Controller {
    static get targets() {
        return ["input"];
    }

    connect() {
        if(!this.hasInputTarget) {
            DEV: throw new Error('[CheckboxValidationController] No input targets found');
        }
        this.resetRequiredState();
    }

    validate(e) {
        if(!this.resetRequiredState()) {
            return;
        }

        this.dispatch('invalid', { prefix: "form", detail: { errorMessage: 'Please select at least one item.'}});
        e.stopImmediatePropagation();
        e.preventDefault();
    }

    resetRequiredState() {
        // If any are checked then the fieldset is valid
        let anyChecked = false;
        for (const $target of this.inputTargets) {
            anyChecked = anyChecked || $target.checked;
        }

        this.setAllRequired(!anyChecked);
        return !anyChecked;
    }

    setAllRequired(state) {
        for (const $target of this.inputTargets) {
            $target.required = state;
        }
    }
}
